import type { LinkProps } from '@iheartjane/reefer';
import { Link } from '@iheartjane/reefer';

import type { StoreViewModel } from '@jane/bloom/viewModels/store';

interface GetDirectionsLinkProps extends Partial<LinkProps> {
  store: Partial<
    Pick<
      StoreViewModel,
      'latitude' | 'longitude' | 'address' | 'city' | 'state' | 'zip'
    >
  >;
}

export const GetDirectionsLink = ({
  store,
  ...linkProps
}: GetDirectionsLinkProps) => {
  const destination = store.address
    ? `${store.address}, ${store.city}, ${store.state} ${store.zip}`
    : `${store.latitude},${store.longitude}`;

  const encodedDestination = encodeURIComponent(destination);

  return (
    <Link
      href={`https://www.google.com/maps/dir/?api=1&destination=${encodedDestination}`}
      color="text-main"
      {...linkProps}
    >
      Get directions
    </Link>
  );
};
